import { AIPrediction, PredictionData } from '@/services/predictions/types';

interface PredictionsCache {
  gold: AIPrediction | null;
  silver: AIPrediction | null;
  lastUpdated: number;
  expiresAt: number;
}

// Cache in memoria con scadenza
let predictionsCache: PredictionsCache = {
  gold: null,
  silver: null,
  lastUpdated: 0,
  expiresAt: 0
};

// Durata della cache: 6 ore (in millisecondi)
const CACHE_DURATION = 6 * 60 * 60 * 1000;

export const getPredictionsFromCache = (): { gold: AIPrediction | null, silver: AIPrediction | null } => {
  const now = Date.now();
  
  // Se la cache è valida, restituisci i dati dalla cache
  if (now < predictionsCache.expiresAt && predictionsCache.gold && predictionsCache.silver) {
    return {
      gold: predictionsCache.gold,
      silver: predictionsCache.silver
    };
  }
  
  // Cache non valida o vuota
  return { gold: null, silver: null };
};

// Funzione che accetta sia AIPrediction[] che PredictionData[]
export const updatePredictionsCache = (predictions: AIPrediction[] | PredictionData[]): void => {
  const now = Date.now();
  
  // Aggiorna la cache con le nuove previsioni
  const gold = predictions.find(p => p.metal === 'ORO') || null;
  const silver = predictions.find(p => p.metal === 'ARGENTO') || null;
  
  // Se abbiamo trovato previsioni, aggiorniamo la cache
  if (gold || silver) {
    // Verifichiamo se le previsioni sono di tipo AIPrediction
    const isAIPrediction = (pred: any): pred is AIPrediction => 
      'id' in pred && 'created_at' in pred;
    
    // Aggiorniamo la cache solo con previsioni di tipo AIPrediction
    if (gold && silver && isAIPrediction(gold) && isAIPrediction(silver)) {
      predictionsCache = {
        gold,
        silver,
        lastUpdated: now,
        expiresAt: now + CACHE_DURATION
      };
      
      console.log('Cache previsioni aggiornata:', predictionsCache);
    } else {
      console.log('Previsioni trovate ma non aggiornate nella cache (formato non compatibile)');
    }
  } else {
    console.log('Nessuna previsione trovata per aggiornare la cache');
  }
};

export const clearPredictionsCache = (): void => {
  predictionsCache = {
    gold: null,
    silver: null,
    lastUpdated: 0,
    expiresAt: 0
  };
  
  console.log('Cache previsioni cancellata');
};
